import { useEffect, useState } from "react";
import ApiService from "../../core/service/api-service";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { dateFormat } from "../../core/utils/date-utils";
import CompactCardList from "../../core/components/CompactCardList";
import JsonViewModal from "../../core/components/JsonViewModal";

// Tek seferde çekilen kayıt sayısı. Liste sayfalanmıyor (detay çekmecesinde sayfa
// düğmeleriyle uğraşmak yerine aşağı kaydırmak istiyoruz); son 100 kayıt yeterli.
const LOG_FETCH_SIZE = 100;

export default function StudyLogsGrid({ studyId }) {
    const { t } = useTranslation();
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState(null);

    // Yükleme göstergesi listenin İÇİNDE (silent: küresel gösterge susar) — bkz. StudyRequestGrid.
    const load = async () => {
        setLoading(true);
        try {
            const response = await ApiService.Study.GetStudyLogs({
                filter: { studyId: studyId },
                paginationQuery: { pageNumber: 1, pageSize: LOG_FETCH_SIZE },
                orderByItems: []
            }, { silent: true });

            if (response.success)
                setLogs(response.data || []);
        }
        finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [studyId]);

    // Kullanıcı alanı "id__görünen ad" biçiminde tutuluyor; kartta yalnız ad gösterilir.
    const userName = (record) => record?.user?.split('__')?.[1] || '-';

    return (
        <>
            <CompactCardList
                items={logs}
                loading={loading}
                rowKey={'id'}
                minVisibleCards={5}
                // Kartta açıklama ya da JSON varsa karta tıklamak da modalı açar.
                onCardClick={(record) => {
                    if (record.data || record.description)
                        setSelected(record);
                }}
                card={(record) => ({
                    title: t(record.type),
                    extra: record.data
                        ? (
                            <Button size={'small'} onClick={() => setSelected(record)}>
                                JSON
                            </Button>
                        )
                        : null,
                    subLeft: dateFormat(record.createdDate),
                    subRight: userName(record),
                    tooltip: record.description
                })}
            />

            <JsonViewModal
                visible={!!selected}
                title={selected ? t(selected.type) : undefined}
                description={selected?.description}
                data={selected?.data}
                onClose={() => setSelected(null)}
            />
        </>
    )
}
